<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<div>
		<!-- 车辆监控页面_固定显示预警切换条开始 -->
		<!-- <div class="alarm_tips" :class="{'maxSizeR':rightSize == 2}">
		  <ul>
		    <li :class="[emgNum===0?'general':'emergency']" @click="showAlarm(1)">
		    	<a>紧<br/>急<br/>报<br/>警<br/>
		    		<span>
		    		{{emgNum}}
		    		</span>
		    		条
		    	</a>
		    </li>
		    <li :class="[ordNum===0?'general':'ordinary']" @click="showAlarm(2)">
		    	<a>一<br/>般<br/>报<br/>警<br/>
		    		<span>
		    			{{ordNum}}
		    		</span>
		    		条
		    	</a>
		    </li>
		    <li class="general" @click="showAlarm(3)">
		    	<a>普<br/>通<br/>提<br/>醒<br/>
		    		<span>
		    			{{genNum}}
		    		</span>
		    	条</a>
		    </li>
		  </ul>
		</div> -->
		<!-- 车辆监控页面_固定显示预警切换条结束 --> 
		<!-- 车辆监控页面_右侧预警信息提示模块开始 -->
		<div :class="{'minSizeR minBtnR':rightSize == 0, 'tab-vertical-right tab-vertical':rightSize != 0,'maxSizeR':rightSize == 2, 'midSizeR':rightSize == 1}" class="rightMonitorTab"> 
		  <div class="tab-title" style="width:100%;" v-show="rightSize != 0">
		  		<div class="dropdown">
			    	<a id="dLabel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			    		<i data-toggle="tabmaptip" data-placement="right" title="显示菜单"></i> 
			    	</a>
			        <ul class="dropdown_menu list-group list02" id="menuR" aria-labelledby="dLabel">
			           <li class="list_group_item" v-for="(tab,index) in mapTabList" @click="goTab(tab.No,tab.name)" :class="{active:mapIndex===index}">{{tab.name}}</li>	         
			        </ul>
			    </div>
			    <!-- <span v-if="mapIndex === 0&&permission.indexOf('vehicleMonitor_alarmPanelDetail') == -1">预警详情</span>  -->
			    <span>{{mapTabTitle}}</span>
			    <em @click="toggleTab" v-show="rightSize==1" class="downArrow" data-toggle="tabmaptip" data-placement="bottom" title="最大"></em>
			    <em @click="toggleTab" v-show="rightSize==2" class="upArrow" data-toggle="tabmaptip" data-placement="bottom" title="最小"></em>
		  </div>
		  <!--右侧悬浮框默认最小状态-->
		   <div @click="toggleTab" v-show="rightSize==0 && mapTabList.length>0" class="minSizeRTxt" data-toggle="tabmaptip" data-placement="bottom" title="半高">
		    	<span></span>
		    </div>
		  <div class="tab-header tab-map">
		    <div id="btnUpR" class="btn1" @mousedown="topMouseDown" @mouseup="topMouseUp" data-toggle="tabmaptip" data-placement="bottom" title="上移"></div>
		    <div class="tabs">
		      <div class="innerTabs">
		        <div class="tab-item" :class="{active:mapIndex === tab.No}" v-for="(tab,index) in mapTabList" @click="goTab(tab.No,tab.name)"><span>{{tab.name}}</span></div>
		      </div>
		    </div>
		    <div id="btnDownR" class="btn2" @mousedown="btmMouseDown" @mouseup="btmMouseUp" data-toggle="tabmaptip" data-placement="top" title="下移"></div>
		  </div>
		  <div class="tab-body tab-map">
		    <div class="tab-content" id="myWeek" v-loading="loadTabMap" element-loading-text="加载中">
		    	<new-panel-box></new-panel-box>     
		    </div>
		  </div>
		</div>
		<!-- 车辆监控页面_右侧预警信息提示模块结束 -->
	</div>
</template>
<script>
	import NewPanelBox from './NewPanelBox'
	import {mapState} from 'vuex'
	import {Mixin} from './mixin.js'
	export default{
		name:'TabMap',
		components:{
			NewPanelBox
		},
		mixins:[Mixin],
		data(){
			return {
				ordNum:0,
				genNum:0,
				emgNum:0,
				tabTitle:'车辆预警',
				rollUp:false
			}
		},
		computed:mapState({
			loadTabMap:state=>state.monitor.loadTabMap,
			mapTabList:state=>state.monitor.mapTabList,
			mapIndex:state=>state.monitor.mapIndex,
			mapTabTitle:state=>state.monitor.mapTabTitle,
			alarmNum:state=>state.monitor.alarmNum,
			rightSize:state=>state.monitor.rightSize//默认右侧悬浮框尺寸  0-最小，1-半高，2-最大
		}),
		watch:{
			alarmNum(val){
				let emgI = val.findIndex(n=>n.almLevel==1)
				if(emgI!=-1){
					this.emgNum = val[emgI].msgCount
				}else{
					this.emgNum = 0
				}
				let ordI = val.findIndex(n=>n.almLevel==2)
					if(ordI!=-1){
						this.ordNum = val[ordI].msgCount
					}else{
						this.ordNum = 0
					}
				
				let genI = val.findIndex(n=>n.almLevel==3)
					if(genI!=-1){
						this.genNum = val[genI].msgCount
					}else{
						this.genNum = 0
					}
			}
		},
		beforeMount(){
			this.$nextTick(function(){
				$(function () {//启用tooltip
				  $('[data-toggle="tabmaptip"]').tooltip()
				})
			})
		//	this.$store.dispatch('getAlarmNum')
		},
		destroyed(){
			$('[data-toggle="tabmaptip"]').tooltip('hide')
		},
		methods: {
			showAlarm(index){
				//1，切换到预警面板
				const obj = {
					id:'VehicleAlarm',
					No:0,
					name:'预警详情'
				}
				this.$store.dispatch('addMapTab',obj)
				//2，获取对应预警
				const param = {
					almLevel:index,
					planOwnerType:1,
					page_index:1
				}
				this.$store.dispatch('showAlarmInfo',param)
			},
			goTab(index,name){
				const obj = {
					No:index,
					name:name
				}
				this.$store.dispatch('goMapTab',obj)
			},
			toggleTab(){
				if(this.rightSize == 0){
					this.$store.dispatch('changeRightSize',1)
				}else if(this.rightSize == 1){
					this.$store.dispatch('changeRightSize',2)	
				}else{
					this.$store.dispatch('changeRightSize',0)
				} 
			},
			topMouseDown(){
				this.handleTopMouseD('.tab-vertical-right','.tab-item')
			},
			topMouseUp(){
				this.handleMouseUp('.tab-vertical-right')
			},
			btmMouseDown(){
				this.handleBtmMouseD('.tab-vertical-right','.tab-item')
			},
			btmMouseUp(){
				this.handleMouseUp('.tab-vertical-right')
			}
		}
	}
</script>

<style scoped>
	.emergency,.ordinary{
		-webkit-animation: twinkling 1s infinite ease-in-out;
		-moz-animation: twinkling 1s infinite ease-in-out; 
		-o-animation:twinkling 1s infinite ease-in-out;
		animation:twinkling 1s infinite ease-in-out;
	}

	@-webkit-keyframes twinkling{ 
		0%{ opacity: 0.5; } 
		100%{ 
		opacity: 1; 
		} 
	} 
	@-moz-keyframes twinkling{ 
		0%{ opacity: 0.5; } 
		100%{ 
		opacity: 1; 
		} 
	}
	@-o-keyframes twinkling{ 
		0%{ opacity: 0.5; } 
		100%{ 
		opacity: 1; 
		} 
	}  
	@keyframes twinkling{ 
		0%{ opacity: 0.5; } 
		100%{ opacity: 1; } 
	}
</style>


// WEBPACK FOOTER //
// TabMap.vue?ea2c87fa